module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_1.df0fc8d8.png";